import React, { useEffect, useState } from "react";

import Button from "../../components/buttons/Button";
import InputField from "../../components/Inputs/InputField";
import Select from "../../components/Inputs/Select";
import * as serviceApi from "../../hooks/useServiceData";
import { useNavigate } from "react-router-dom";
import { GetAccountingPlans } from "../../hooks/useGeneralData";
import Check from "../../components/Inputs/Check";
import { useSnackbar } from "notistack";

export const CreateActivityModal = (props) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [ownerId, setOwnerId] = useState("");
  const [name, setName] = useState("");
  const [cost, setCost] = useState();
  const [isActive, setIsActive] = useState(true);

  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState();

  const { data } = GetAccountingPlans();
  // console.log("data: ", data);

  const { mutate } = serviceApi.CreateActivity();

  useEffect(() => {
    let accountList = [];

    if (data?.data) {
      accountList = data?.data.map((account) => {
        return {
          value: account.id,
          label: `${account.number} ${account.name}`,
        };
      });
      setAccounts(accountList);
    }
  }, [data]);

  const createActivity = () => {
    let _activity = {};

    _activity.owner_id = ownerId;
    _activity.name = name;
    _activity.cost = cost;
    _activity.account = account;
    _activity.isActive = isActive;

    mutate(_activity, {
      onSuccess: (response) => {
        const activityId = response.data.raw.insertId;
        enqueueSnackbar("Aktivitet skapad.", {
          variant: "success",
        });
        navigate(`/registry/activity/details/${activityId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Aktivitet kunde inte skapas.", {
          variant: "error",
        });
        console.log("ERROR POSTING ACTIVITY: ", error);
      },
    });
  };

  return (
    <>
      <form
        className="container"
        style={{ width: "100%" }}
        onSubmit={(e) => {
          e.preventDefault();
          createActivity();
        }}
      >
        <InputField
          required
          type="text"
          label="Namn"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputField
          required
          type="text"
          label="Ange ID"
          value={ownerId}
          onChange={(e) => setOwnerId(e.target.value)}
        />
        <InputField
          required
          type="number"
          label="Ange Kostnad"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
        />
        <Select
          required
          options={accounts}
          label={"Ange Kontoplan"}
          onChange={(event, item) => setAccount(item.value)}
        />
        <div className="create-active-check-container">
          <Check
            color="success"
            label="Aktiv Aktivitet"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
        </div>
        <div className="rightAlign-button-container">
          <Button type="submit" color="success">Skapa Aktivitet</Button>
          <Button
            variant="outlined"
            onClick={() => props.closeCreateModal()}
          >
            Stäng
          </Button>
        </div>
      </form>
    </>
  );
};
